import { Component, OnInit } from '@angular/core';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { CategoriaAdminListResponse } from 'src/app/modal/categoria/categoriaAdminListResponse';
import { CategoriaService } from 'src/app/service/categoria/categoria.service';
import { RespuestaComun } from 'src/app/modal/maestras/respuesta-comun';
import { DmlCategoriaComponent } from 'src/app/pagina-admin/dashboard/gestionLibros/mant-categoria/dml-categoria/dml-categoria.component';

@Component({
  selector: 'app-mant-categoria',
  templateUrl: './mant-categoria.component.html',
  styleUrls: ['./mant-categoria.component.scss']
})

export class MantCategoriaComponent implements OnInit {

  constructor(private categoriaService:CategoriaService,
    private utilitarioService: UtilitarioService,
    private maestrasService: MaestrasService,
    private modalService: MDBModalService,
    ) { }

  txtdescripcion:String = "";
  cboEstado:String = "";
  modalRefCategoriaDml: MDBModalRef;
  listEstado:RespuestaComun = new RespuestaComun();
  headElements = ['Categoría','Fecha Creado', 'Estado','Editar'];
  listCategoria:CategoriaAdminListResponse = new CategoriaAdminListResponse();
  
  page = 1;
  pageSize = 9;

  ngOnInit(): void {
    this.cargarDatoInicial();
    this.onBuscar();
  }

  onBuscar(){
    this.utilitarioService.loading = true;
    this.categoriaService.obtenerCategoriaAdminList(this.txtdescripcion.toString(), this.cboEstado.toString()).subscribe(data=>{
      this.listCategoria = data;
      // console.log(data);
      this.utilitarioService.loading = false;
    })
  }

  onNuevo(id:String){
    this.modalRefCategoriaDml = this.modalService.show(DmlCategoriaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: id,
          x_titulo:'Nuevo Categoría',
          x_proceso:'I',
        }
      }
    );
  }

  onEditar(id:String){
    this.modalRefCategoriaDml = this.modalService.show(DmlCategoriaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          id: id,
          x_titulo:'Editar Categoria',
          x_proceso:'U',
        }
      }
    );
  }

  cargarDatoInicial(){

    this.utilitarioService.loading = true;
    this.listEstado = new RespuestaComun();
    this.maestrasService.obtenerMaestra("TIPO_STATUS_TABLA").subscribe(data=>{
      this.listEstado = data;      
      this.utilitarioService.loading = false;
    });

  }

}
